export default "__VITE_ASSET__e0d307f9__"